<h4 mat-dialog-title>Add Customer</h4>
<mat-dialog-content>
  <sn-customer-search [customerID]="" (customer)="customerSelected($event)" [requireContract]="false"></sn-customer-search>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="dialog-footer-buttons">Cancel</button>
  <button mat-raised-button color="primary" class="dialog-footer-buttons" (click)="addCustomer()" [disabled]="!selectedCustomer">Add</button>
</mat-dialog-actions>
